(function () {
  var EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  var messages = {
    required: function (label) {
      return label + ' is required';
    },
    email: function () {
      return 'Please enter a valid email address';
    },
    consent: function () {
      return 'You must accept the privacy policy';
    }
  };

  function clearFieldError(field) {
    field.classList.remove('enquiry-form__input--error');
    var group = field.closest('.enquiry-form__field-group') || field.closest('.enquiry-form__consent');
    if (!group) return;
    var errorEl = group.querySelector('.enquiry-form__field-error');
    if (errorEl) {
      errorEl.textContent = '';
      errorEl.classList.remove('enquiry-form__field-error--visible');
    }
  }

  function showFieldError(field, message) {
    field.classList.add('enquiry-form__input--error');
    var group = field.closest('.enquiry-form__field-group') || field.closest('.enquiry-form__consent');
    if (!group) return;
    var errorEl = group.querySelector('.enquiry-form__field-error');
    if (errorEl) {
      errorEl.textContent = message;
      errorEl.classList.add('enquiry-form__field-error--visible');
    }
  }

  function validateField(field) {
    var rules = (field.getAttribute('data-validation') || '').split('|').filter(Boolean);
    var label = field.getAttribute('data-label') || 'Field';
    var value = field.type === 'checkbox' ? field.checked : (field.value || '').trim();

    for (var i = 0; i < rules.length; i++) {
      var rule = rules[i];

      if (rule === 'required' && !value) {
        return messages.required(label);
      }

      if (rule === 'email' && value && !EMAIL_REGEX.test(value)) {
        return messages.email();
      }

      if (rule === 'consent' && !value) {
        return messages.consent();
      }
    }

    return null;
  }

  function validateForm(form) {
    var fields = form.querySelectorAll('[data-validation]');
    var firstInvalid = null;
    var isValid = true;

    fields.forEach(function (field) {
      clearFieldError(field);
      var error = validateField(field);
      if (error) {
        isValid = false;
        showFieldError(field, error);
        if (!firstInvalid) firstInvalid = field;
      }
    });

    if (firstInvalid) {
      var focusTarget = firstInvalid.type === 'checkbox'
        ? firstInvalid.closest('.enquiry-form__consent')
        : firstInvalid;
      if (focusTarget) focusTarget.scrollIntoView({ behavior: 'smooth', block: 'center' });
      if (firstInvalid.type !== 'checkbox') firstInvalid.focus();
    }

    return isValid;
  }

  function bindLiveClearing(form) {
    form.addEventListener('input', function (e) {
      var field = e.target;
      if (field.getAttribute('data-validation')) {
        clearFieldError(field);
      }
    });

    form.addEventListener('change', function (e) {
      var field = e.target;
      if (field.getAttribute('data-validation')) {
        clearFieldError(field);
      }
    });
  }

  function initPopup(popup) {
    var productFormId = popup.getAttribute('data-product-form-id');
    if (!productFormId) return;

    popup.addEventListener('dialog:open', function () {
      var productForm = document.getElementById(productFormId);
      var variantInput = productForm && productForm.querySelector('input[name="id"]');
      var enquiryForm = popup.querySelector('.enquiry-form');
      var hiddenVariantId = enquiryForm && enquiryForm.querySelector('input[name="contact[variant_id]"]');
      if (hiddenVariantId && variantInput) {
        hiddenVariantId.value = variantInput.value || '';
      }
    });

    var enquiryForm = popup.querySelector('.enquiry-form');
    if (!enquiryForm) return;

    enquiryForm.setAttribute('novalidate', '');
    bindLiveClearing(enquiryForm);

    var submitBtn = enquiryForm.querySelector('.enquiry-form__submit');

    function blockSubmit(e) {
      if (!validateForm(enquiryForm)) {
        e.preventDefault();
        e.stopImmediatePropagation();
      }
    }

    if (submitBtn) {
      submitBtn.addEventListener('click', blockSubmit, true);
    }

    enquiryForm.addEventListener('submit', blockSubmit, true);
  }

  document.querySelectorAll('.enquiry-drawer[data-product-form-id]').forEach(initPopup);
})();
